import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeRu from '@angular/common/locales/ru';
import { LOCALE_ID, NgModule } from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import moment from 'moment-mini-ts';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SPErrorHandlerProviders } from './common/http-error-handlers';
import { httpInterceptorProviders } from './interceptors';
import { ApiPayService } from './services/api-pay.service';
import { ApiService } from './services/api.service';
import { DialogService } from './services/dialog.service';
import { DicService } from './services/dic.service';
import { DictionaryDataService } from './services/dictionary-data.service';
import { EventsService } from './services/events.service';
import { HostMessageService } from './services/host-message.service';
import { ModalService } from './services/modal.service';
import { PreloaderService } from './services/preloader.service';
import { PreviousRouteService } from './services/previous-route.service';
import { ProfileService } from './services/profile.service';
import { SettingsService } from './services/settings.service';
import { StorageService } from './services/storage.service';
import { VkAuthWrap } from './shared/classes/vk-auth';
import { DialogComponent } from './shared/components/dialog/dialog.component';
import { VkCommunityInstallComponent } from './shared/components/vk-community-install/vk-community-install.component';
import { SharedModule } from './shared/shared.module';

const firebaseConfig = {
  apiKey: 'AIzaSyCYoa1Jek2C9a38nhOs8goOaGpJlOPgPrs',
  authDomain: 'sport-priority-services.firebaseapp.com',
  databaseURL: 'sport-priority-services.firebaseio.com',
  storageBucket: '',
  messagingSenderId: '',
};

registerLocaleData(localeRu);
moment.locale('ru');

@NgModule({
  declarations: [AppComponent, DialogComponent, VkCommunityInstallComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule,
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
  ],
  providers: [
    PreviousRouteService,
    HostMessageService,
    EventsService,
    SettingsService,
    ApiService,
    ApiPayService,
    ModalService,
    PreloaderService,
    ProfileService,
    StorageService,
    DialogService,
    httpInterceptorProviders,
    VkAuthWrap,
    SPErrorHandlerProviders,
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    DicService,
    DictionaryDataService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
